<template>
    <section class="appointment">
        <common-page-header
            v-if="isReferralPool"
            :heading="$t('pages.referrals.pool.please_select_3_time_slots')"
            size="small"
            contentSpacing="medium"
        ></common-page-header>
        <header class="appointment__header">
            <div class="appointment__months-input">
                <select-input
                    :value="{ year, month }"
                    :options="monthOptions"
                    @change="changeCurrentMonth($event)"
                ></select-input>
            </div>

            <div class="appointment__months-switch">
                <schedule-months-switch
                    :value="{ year, month }"
                    :options="monthOptions"
                    size="large"
                    @change="changeCurrentMonth($event)"
                ></schedule-months-switch>
            </div>
        </header>

        <div class="appointment__calendar">
            <schedule-calendar
                ref="scheduleCalendar"
                :year="year"
                :month="month"
                :dates="dates"
                :physician="physician"
                :practice="practice"
                :location="location"
                :selectedSlotsByDate="selectedSlotsByDate"
                @emitEvent="emitEvent($event)"
            ></schedule-calendar>
        </div>
    </section>
</template>

<script>
    import { importComponents } from '~/helpers'
    import dayjs from 'dayjs'
    import UsersAPI from 'api/UsersAPI'
    import PracticesAPI from 'api/PracticesAPI'
    import SelectInput from 'components/form-inputs/SelectInput'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import ScheduleDatesToCalendarDataTransformer from 'transformers/ScheduleDatesToCalendarDataTransformer'

    export default {
        components: {
            ...importComponents(require.context('components/page-elements/referrals-new-schedule')),
            SelectInput,
        },

        props: {
            physician: { type: Object, required: true },
            practice: { type: Object, required: true },
            location: { type: Object, required: true },
            selectedSlotsByDate: { type: Object, required: false, default: undefined },
        },

        inject: {
            isReferralPool: {
                default: false,
            },
        },

        data() {
            return {
                dates: {},
                year: dayjs().year(),
                month: dayjs().date() > 25 && this.$auth.isUserPracticeDemo() ? dayjs().month() + 1 : dayjs().month(),
            }
        },

        computed: {
            monthOptions() {
                return Array(12)
                    .fill(dayjs())
                    .map((month, index) => ({
                        label: month.add(index, 'months').format('MMMM YYYY'),
                        value: {
                            year: month.add(index, 'months').year(),
                            month: month.add(index, 'months').month(),
                        },
                    }))
            },
        },

        methods: {
            changeCurrentMonth({ year, month }) {
                this.year = year
                this.month = month
                this.getAvailableDates()
            },

            getAvailableDates() {
                if (this.$auth.isUserPracticeDemo()) {
                    const today = dayjs()
                    const dates = []

                    if (today.date() > 25 && this.$auth.isUserPracticeDemo()) {
                        const nextMonth = today.add(1, 'month')
                        for (let i = 1; i <= 3; i++) {
                            dates.push({
                                date: nextMonth.date(i).format('YYYY-MM-DD'),
                                slotCount: 48,
                            })
                        }
                    } else {
                        for (let i = 2; i <= 4; i++) {
                            const nextDate = today.add(i, 'day')
                            dates.push({
                                date: nextDate.format('YYYY-MM-DD'),
                                slotCount: 48,
                            })
                        }
                    }
                    this.dates = ScheduleDatesToCalendarDataTransformer.transform(JSON.stringify(dates))
                    return false
                }

                const params = {
                    ...this.$route.query,
                    month: this.month + 1,
                    year: this.year,
                }
                if (this.$route.query.practiceType === PracticeTypeEnum.ANCILLARY) {
                    PracticesAPI.getAvailableDates(params.practiceId, params).then((res) => {
                        this.dates = res
                    })
                } else {
                    UsersAPI.getAvailableDates(params.physicianId, params).then((res) => {
                        this.dates = res
                    })
                }
            },
        },

        watch: {
            physician() {
                this.getAvailableDates()
            },
        },

        mounted() {
            this.getAvailableDates()
        },
    }
</script>
